let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("63WWP")).then(() => parcelRequire('50VmZ'));